import {
  AssistantKnowledgeBaseFunction,
  AssistantPluginCall,
  AssistantSkillsPluginCall,
  FunctionToolCallType,
  InputItemList,
  InputMessageType,
  OutputCodeInterpreterToolCall,
  OutputFileSearchToolCall,
  OutputType,
} from "../types/common";

export function isFunctionCall(
  item: InputItemList[number],
): item is FunctionToolCallType {
  return item.type === "function_call";
}

export function isMessage(
  item: InputItemList[number],
): item is InputMessageType {
  return item.type === "message";
}

export function isMessageInput(
  item: InputItemList[number],
): item is InputMessageType {
  const messageItem = item as InputMessageType;

  return messageItem.role === "user";
}

export function isFileSearchCall(
  item: OutputType[number],
): item is OutputFileSearchToolCall {
  return item.type === "file_search_call";
}

export function isCodeInterpreterCall(
  item: OutputType[number],
): item is OutputCodeInterpreterToolCall {
  return item.type === "code_interpreter_call";
}

export function isCallAssistantFunction(
  item: FunctionToolCallType,
): item is AssistantPluginCall {
  return item.name === "plugin_call_external_assistant";
}

export function isCallKnowledgeBaseFunction(
  item: FunctionToolCallType,
): item is AssistantKnowledgeBaseFunction {
  return (
    item.name === "openai_query_knowledge_base" ||
    item.name === "query_knowledge_base"
  );
}

export function isCallAssistantSkillFunction(
  item: FunctionToolCallType,
): item is AssistantSkillsPluginCall {
  return item.name === "plugin_call_skill";
}
